import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailers-filter_interaction-action_unknown';
/**
 * Filter interaction like
Open section
Close section

Parameters:
1. Name of the filter
2. Action
3. Section Name
*/
export function trackRetailersFilterInteraction(customParameterToken, customParameterToken2, customParameterToken3) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: {
            customParameterToken,
            customParameterToken2,
            customParameterToken3,
        },
    });
}
